import script from "./TradeView.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeView.vue?vue&type=script&setup=true&lang=js"

import "./TradeView.vue?vue&type=style&index=0&id=e206fe36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e206fe36"]])

export default __exports__